<template>
  <div class="fill-height"
    :style="[
      {'background-color': `#F4F4F4`} 
    ]"
  >
    <strategio-app-bar v-if="showStrategioAppBar"></strategio-app-bar>
    <v-main style="height:100vh;padding-top:87px">
      <div style="max-height:100%; overflow:auto">
        <user-form 
          :user-data="user" 
          is-my-account 
          parent-route="/" 
          back-button-text="Pagina principal"
          :showStrategioAppBar="showStrategioAppBar"
        ></user-form>
      </div>

    </v-main>
  </div>
</template>

<script>
import StrategioAppBar from '../components/header-bar/strategio-app-bar.vue'
import UserForm from '../components/users/user-form'
import userStorage from '../storage/userStorage'

export default {
  name: 'user-account',
  data () {
    return {
      user: userStorage.getUserInfo(),
      showStrategioAppBar: true
    }
  },
  components: {
    StrategioAppBar,
    UserForm
  },
  mounted () {
    // console.log(`On beforeRouteUpdate with ${this.$route.params.showStrategioAppBar}`)
    this.showStrategioAppBar = this.$route.params.showStrategioAppBar === undefined ? true : this.$route.params.showStrategioAppBar
    // console.log(`After beforeRouteUpdate with ${this.$route.params.showStrategioAppBar}`)
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/routes/user-account.vue